import "phaser";
//import { Game } from "phaser";
// import { TEXT_GRADIENT } from "pixi.js";
import App from "../main";
import { Game, GameState } from '../app/game'
import Car from "../Sprites/Car";
import { GAMEZOP_INIT_DATA, GAMEZOP_STATE, GameZopSDK, GamezopGame } from "./libs/GameZopSDK";
import { GameConfig } from "./Utils";

export enum PHONE_TYPE { LOW = 0, MEDIUM = 1, HIGH = 2, PAD = 3, OUT = 4 }

export default class UIManager extends Phaser.Scene implements GamezopGame {

    public feedbackText: Phaser.GameObjects.Text;
    public respawnText: Phaser.GameObjects.Text;
    public respawnTextUI: Phaser.GameObjects.Text;
    public levelUpText: Phaser.GameObjects.Text;
    public finalScoreText: Phaser.GameObjects.Text;
    public gameOverText: Phaser.GameObjects.Text;
    public currentScoreText: Phaser.GameObjects.Text;
    public gameStartText: Phaser.GameObjects.Text;
    public highScoreText: Phaser.GameObjects.Text;
    public highScoreTextUI: Phaser.GameObjects.Text;
    public replayText: Phaser.GameObjects.Text;
    public pauseText: Phaser.GameObjects.Text;
    public watchAdText: Phaser.GameObjects.Text;
    public watchAdCountDownText: Phaser.GameObjects.Text;
    public continueText: Phaser.GameObjects.Text;
    public blackScreenText: Phaser.GameObjects.Text;
    public static battleModeTimerText: Phaser.GameObjects.Text;

    startLogo: Phaser.GameObjects.Sprite;




    feedbackTextTween: any;

    countDownTween: any;

    hud: Phaser.GameObjects.Container;
    pauseScreen: Phaser.GameObjects.Container;
    rewardAdsScreen: Phaser.GameObjects.Container;
    respawnScreen: Phaser.GameObjects.Container;
    gameOverScreen: Phaser.GameObjects.Container;
    blackScreenContainer: Phaser.GameObjects.Container;
    blackBorderContainer: Phaser.GameObjects.Container;


    scoreHUD: Phaser.GameObjects.Text;
    livesHUD: Phaser.GameObjects.Text;


    highScoreGratification: Phaser.GameObjects.Sprite;
    gameOverPanel: Phaser.GameObjects.Sprite;
    respawnPanel: Phaser.GameObjects.Sprite;
    replayButton: Phaser.GameObjects.Sprite;
    pauseButton: Phaser.GameObjects.Sprite;
    resumeButton: Phaser.GameObjects.Sprite;
    restartButton: Phaser.GameObjects.Sprite;
    exitButton: Phaser.GameObjects.Sprite;
    audioToggle: Phaser.GameObjects.Sprite;
    audioToggleButton: Phaser.GameObjects.Sprite;
    continueButton: Phaser.GameObjects.Sprite;
    BlackScreenSprite: Phaser.GameObjects.Sprite;


    watchAdButton: Phaser.GameObjects.Sprite;
    cancelAdButton: Phaser.GameObjects.Sprite;

    heartIcon: Phaser.GameObjects.Sprite;
    scoreIcon: Phaser.GameObjects.Sprite;
    currentScorediamondIcon: Phaser.GameObjects.Sprite;
    highScoreDiamondIcon: Phaser.GameObjects.Sprite;

    blackScreenPause: Phaser.GameObjects.Sprite;
    blackScreenRight: Phaser.GameObjects.Sprite;
    blackScreenLeft: Phaser.GameObjects.Sprite;

    gameLogo: Phaser.GameObjects.Sprite;
    blackPanel: Phaser.GameObjects.Sprite;
    gameScene: Phaser.Scene;

    soundOn: boolean = true;

    public static respawnTimeout: any;

    centerX: number;
    centerY: number;

    width: number;
    height: number;

    finalScore: number = 0;
    finalScoreOffSet: number = 0;
    highScoreOffSet: number = 0;

    highScore: number = 0;
    testScore: number = 0;

    buttonSFX: Phaser.Sound.BaseSound;
    gameFireEvent: boolean = false;


    constructor() {
        super('ui');
    }


    mute(): void {
        this.muteAudio();
    };

    unmute(): void {
        this.unMuteAudio();
    }

    gameReady() {

    }

    gameInit(initData: GAMEZOP_INIT_DATA): void {
        if (initData.matchId == '') {
            return;
        }
        this.gameFireEvent = false;
        this.registry.set('score', 0);
        this.writeVar('score', 0);
        App.gamezopSDK.setGameState(GAMEZOP_STATE.PLAYING, this.finalScore, App.gamezopSDK.getHighscore());
        // this.Restart();

        this.startTheTimer();
        // this.gameScene.events.emit('onGameStart');
    }

    gameEnd(): void {
        if (!this.gameFireEvent) {
            this.gameFireEvent = true;
            this.endBattleMode();
            Game.uiScene.events.emit('EndGame');
            if(!this.eventFired){
                App.gamezopSDK.setGameState(GAMEZOP_STATE.OVER, this.finalScore, App.gamezopSDK.getHighscore());
            }
        }
    }

    getGameConfig(): any {
        return this.getHighScoreFromCloud();
        // return GameConfig;
    }

    gameContinue() {
        this.Restart();
    }

    getRandomInt(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    writeVar(name: string, value: number) {
        let mover = Math.round(this.getRandomInt(1000, 10000));
        App.gamezopSDK.store.set(name, (value + mover) * -1);
        App.gamezopSDK.movers.set(name, mover);
    }

    preload() {
        App.gamezopSDK.setGame(this);
        // App.gamezopSDK.getMetadata();
        this.load.multiatlas('sprites', 'Sprites/sprites.json', 'Sprites');
        this.load.image('greenbutton', 'buttongreen.png');
        this.load.image('panel', 'panel.png');
        this.load.image('scorePanel', 'scorepanel.png');
        this.load.image('new', 'new.png');
        this.load.image('slingRacer', 'Sprites/slingRacer.png');
    }

    create() {

        App.gamezopSDK.setGame(this);

        this.gameScene = this.scene.get('game');

        this.width = this.cameras.main.width;
        this.height = this.cameras.main.height;

        this.centerX = this.width / 2;
        this.centerY = this.height / 2;

        this.levelUpText = this.createGlobalText("LEVEL UP")

        this.watchAdText = this.createText("Play an ad to\n    continue?", this.centerX, this.centerY - 150);
        this.watchAdText.setVisible(false);
        this.watchAdText.setDepth(12)
        this.SetTextStyle(this.watchAdText, 35, 10)

        this.watchAdCountDownText = this.createText("5", this.centerX, this.centerY - 50);
        this.watchAdCountDownText.setVisible(false);
        this.watchAdCountDownText.setDepth(12)
        this.SetTextStyle(this.watchAdCountDownText, 35, 10)

        //EVENTS
        this.gameScene.events.on('menu', () => { this.TweenStartText() });
        this.gameScene.events.on('addScore', (score) => { this.updateScore(score) });
        this.gameScene.events.on('gameStart', () => { this.GameStart() });
        this.gameScene.events.on('gameover', () => { this.OnGameOver() });
        this.gameScene.events.on('perfectTurn', (count) => { this.OnPerfectTurn(count) });
        this.gameScene.events.on('levelUp', () => { this.OnLevelUp() });
        this.gameScene.events.on('respawnUI', (lives) => { this.Respawn(lives) });
        this.gameScene.events.on('updateLifeUI', (lives) => { this.updateLifeUI(lives) });
        this.gameScene.events.on('tutorial', () => { this.Tutorial() });
        this.gameScene.events.on('watchAD', () => { this.openWatchAdScreen() });
        this.gameScene.events.on('onGameEndUI', () => { this.OnGameEndReplay() });
        this.gameScene.events.on('continueRespawn', () => { this.continueRespawn() });
        this.gameScene.events.on('onPause', () => { this.OnPause() });
        this.gameScene.events.on('onSdkPause', () => { this.sdkPause() });
        this.gameScene.events.on('onSdkResume', () => { this.sdkResume() });




        //CONTAINERS
        this.hud = this.add.container(this.centerX, this.centerY);
        this.pauseScreen = this.add.container(this.centerX, this.centerY);
        this.rewardAdsScreen = this.add.container(this.centerX, this.centerY);
        this.respawnScreen = this.add.container(this.centerX, this.centerY);
        this.gameOverScreen = this.add.container(this.centerX, this.centerY);
        this.blackScreenContainer = this.add.container(this.centerX, this.centerY);
        this.blackBorderContainer = this.add.container(this.centerX, this.centerY);

        //Panel
        this.blackPanel = this.add.sprite(this.centerX, this.cameras.main.height / 2 - 200, 'sprites', 'blackPanel.jpg');
        this.blackPanel.setDepth(1);
        this.blackPanel.scale = 0.5;
        this.blackPanel.setVisible(false);


        this.createGameHud();
        // this.createBlackBorderScreen();
        this.createPauseScreen();
        this.createWatchAdScreen();
        this.createRespawnScreen();
        this.createGameEndScreen();
        this.createBlackScreen();

        this.time.addEvent({
            delay: 100,
            callback: function () {
                // this.highScore = GameConfig.highScore;
                this.TweenStartText();
                Game.currentGameState = 0;
                this.updateLifeUI(App.totalLives);
            },
            callbackScope: this
        });
        this.TweenStartText();
        this.buttonSFX = this.game.sound.add('click');
        // this.getHighScoreFromCloud();
        this.isBattleModeIcons();
        this.tweenTexts();
        this.checkAudioFromGamezop();
    }

    getHighScoreFromCloud() {
        console.log("Metadata", App.gamezopSDK.gamezop.data.metadata);

        if (typeof App.gamezopSDK.gamezop.data.metadata === "undefined") {
            this.highScore = 0;
            this.setHighScoreToCloud(this.highScore);
            console.log("Get highscore", this.highScore);
        } else {
            if (!Object.keys(App.gamezopSDK.gamezop.data.metadata).length) {
                this.highScore = 0;
                this.setHighScoreToCloud(this.highScore);
            } else {
                this.highScore = App.gamezopSDK.gamezop.data.metadata.highscore;
            }
            console.log("Get highscore", this.highScore);
        }

    }

    setHighScoreToCloud(highscore: number) {
        App.gamezopSDK.gamezop.data.metadata.highscore = highscore;
    }

    checkAudioFromGamezop() {
        if (Game.isSoundOn) {
            this.unMuteAudio();
        } else {
            this.muteAudio();
        }
    }

    isBattleModeIcons() {
        if (Game.isBattleMode) {
            // this.heartIcon.setVisible(false);
            // this.livesHUD.setVisible(false);
            this.pauseButton.setVisible(false);
        }
        else {
            this.heartIcon.setVisible(true)
            this.livesHUD.setVisible(true);
            this.pauseButton.setVisible(true);
        }
    }

    public showAd() {
        // console.log("Can show Ad", App.gamezopSDK.gamezop.showAd);
        App.gamezopSDK.gamezop.showAd({ type: "nonskipvideo" }, this.isAdRewarded);
    }

    public isAdRewarded(value: boolean) {
        this.replayButton.setVisible(true);
        this.replayText.setVisible(true);
        if (value) {
            console.log("Reward player");
            return
        } else {
            console.log("Dont revive player");
        }
    }


    createGameHud() {

        this.scoreIcon = this.add.sprite(-(this.width * 0.5) * 0.98 , -(this.height * 0.5) * 0.92, 'sprites', 'points.png');
        this.scoreIcon.setOrigin(0, 0.5);
        this.scoreIcon.setScale(0.6);
        this.scoreHUD = this.createText("0", this.scoreIcon.x + this.scoreIcon.width * 0.38, this.scoreIcon.y);

        this.heartIcon = this.add.sprite(-(this.width * 0.5) * 0.95 , -(this.height * 0.5) * 0.78, 'sprites', 'lives.png');
        this.heartIcon.setOrigin(0, 0.5);
        this.heartIcon.setScale(0.6);
        this.livesHUD = this.createText("X " + App.totalLives, this.heartIcon.x + this.heartIcon.width * 0.4 + 5, this.heartIcon.y - 3);

        this.pauseButton = this.createButton((this.width * 0.5) * 0.95 , -(this.height * 0.5) * 0.98, 'pause.png', this.OnPause.bind(this))
        this.pauseButton.setOrigin(1, 0);
        this.pauseButton.setScale(0.5);

        this.audioToggleButton = this.createButton((this.width * 0.5) * 0.95, (this.height * 0.5) * 0.98, 'soundOn.png', this.ToggleAudio.bind(this));
        this.audioToggleButton.setOrigin(1, 1);
        this.audioToggleButton.setScale(0.5);
        this.audioToggleButton.setVisible(true);

        if (Game.isBattleMode) {
            this.gameStartText = this.createText("PLEASE WAIT...", 0, -120);
            UIManager.battleModeTimerText = this.createText("Time: ", 0, 0);
            UIManager.battleModeTimerText.setVisible(false);
            this.SetTextStyle(UIManager.battleModeTimerText, 25, 5);

        } else {
            this.gameStartText = this.createText("TAP TO START", 0, -100);
        }

        this.feedbackText = this.createText(" ", 0, -200);
        this.SetTextStyle(this.feedbackText, 35, 15);


        this.hud.add([this.scoreHUD, this.livesHUD, this.heartIcon, this.scoreIcon, this.pauseButton, this.audioToggleButton, this.feedbackText, this.gameStartText]);
        this.hud.scale = 1;
        this.hud.sendToBack(this.scoreIcon);
        this.hud.sendToBack(this.heartIcon);
        this.hud.setVisible(false);

        // log the hud container to see what it looks like
        this.startLogo = this.add.sprite(this.centerX,this.centerY +200,'slingRacer');
        this.startLogo.alpha = 0;
        this.startLogo.setVisible(true);
        this.startLogo.setScale(0.2,0.2)
        this.tweens.add({
            targets: this.startLogo,
            alphaTopLeft: { value: 1, duration: 800, ease: 'Power1' },
            alphaTopRight:{value: 1, duration: 800, ease: 'Power1'},
            alphaBottomRight: { value: 1, duration: 800, ease: 'Power1' },
            alphaBottomLeft: { value: 1, duration: 800, ease: 'Power1'},
        });
    }

    createText(content: string, x: number, y: number): Phaser.GameObjects.Text {
        let text = this.add.text(x, y, content)
        text.setOrigin(0.5, 0.5);
        return text;
    }

    createButton(x, y, key, callback: Function, isActive: boolean = false): Phaser.GameObjects.Sprite {
        let button = this.add.sprite(x, y, 'sprites', key)
        button.setDepth(11);
        button.on('pointerdown', callback)
        button.setInteractive();
        button.setVisible(isActive)
        // this.input.enableDebug(button);
        return button;
    }

    create_Button(x, y, imageName: string, callback: Function, isActive: boolean = false): Phaser.GameObjects.Sprite {
        let button = this.add.sprite(x, y, imageName);
        button.setDepth(11);
        button.on('pointerdown', callback)
        button.setInteractive();
        button.setVisible(isActive)
        // this.input.enableDebug(button);
        return button;
    }

    SetTextStyle(text: Phaser.GameObjects.Text, size: number, stroke: number, fontFamily?: string) {
        if (!fontFamily) {
            fontFamily = 'bungee'
        }
        text.setStyle({ fontFamily: fontFamily, fontSize: size.toString() + 'px', color: '#E6E6E6', stroke: '#281a37', strokeThickness: stroke });
    }

    createGlobalText(content: string): Phaser.GameObjects.Text {
        let text = this.createText(content, this.cameras.main.width / 2, this.cameras.main.height / 2 - 200);
        text.setDepth(10);
        text.alpha = 0;
        return text;
    }

    createPauseScreen() {
        this.resumeButton = this.createButton(-60, 0, 'resume.png', this.Resume.bind(this), true)
        // this.audioToggle = this.createButton(0, 0, 'soundOn.png', this.ToggleAudio.bind(this), true)
        this.restartButton = this.createButton(60, 0, 'replay.png', this.Restart.bind(this), true)

        this.blackScreenPause = this.add.sprite(0, 0, 'sprites', 'black.jpg');
        this.blackScreenPause.setScale(5);
        this.blackScreenPause.setAlpha(0.5);

        this.pauseText = this.createText("PAUSED", 0, -200)
        this.pauseText.setDepth(12);
        this.SetTextStyle(this.pauseText, 45, 10);

        this.pauseScreen.add([this.blackScreenPause, this.resumeButton, this.restartButton, this.pauseText]);

        this.pauseScreen.setDepth(10)
        this.ClosePauseWindow(false)
    }

    createRespawnScreen() {
        this.respawnTextUI = this.createGlobalText("RESPAWN")
        this.SetTextStyle(this.respawnTextUI, 40, 5);
        this.respawnTextUI.setPosition(0, -170);
        this.respawnTextUI.alpha = 1;

        this.continueButton = this.create_Button(0, 100, 'greenbutton', this.continueRespawn.bind(this), true);

        this.continueText = this.createText("CONTINUE", 0, 100);
        this.SetTextStyle(this.continueText, 25, 5);
        this.continueText.setDepth(12);

        this.respawnPanel = this.add.sprite(0, 0, 'panel');
        this.respawnPanel.setDepth(1);
        this.respawnPanel.scale = 0.85;

        this.respawnText = this.createGlobalText("Continue In")
        this.SetTextStyle(this.respawnText, 30, 0);
        this.respawnText.setPosition(0, -40);
        this.respawnText.alpha = 1;

        this.respawnScreen.add([this.respawnPanel, this.continueButton, this.continueText, this.respawnTextUI, this.respawnText]);
        this.respawnScreen.setDepth(10);
        this.respawnScreen.scale = 1;
        this.enableRespawnScreen(false);
    }

    createBlackScreen() {
        this.BlackScreenSprite = this.add.sprite(0, 0, 'sprites', 'black.jpg');
        this.BlackScreenSprite.setScale(5);
        this.BlackScreenSprite.setAlpha(0.5);

        this.blackScreenText = this.createText("Please Wait...", 0, 0);
        this.SetTextStyle(this.blackScreenText, 30, 10);

        this.blackScreenContainer.add([this.BlackScreenSprite, this.blackScreenText]);
        this.blackScreenContainer.setVisible(false);
    }

    createBlackBorderScreen() {
        let rightBlackScreenX: number = 3400;
        let leftBlackScreenX: number = -3400
        this.blackScreenRight = this.add.sprite(rightBlackScreenX, 0, 'sprites', 'black.jpg');
        this.blackScreenRight.setScale(5);

        this.blackScreenLeft = this.add.sprite(leftBlackScreenX, 0, 'sprites', 'black.jpg');
        this.blackScreenLeft.setScale(5);

        this.blackBorderContainer.add([this.blackScreenRight, this.blackScreenLeft]);
        this.blackBorderContainer.setVisible(true);
    }

    // Ad flow
    createWatchAdScreen() {
        this.watchAdButton = this.createButton(-120, 50, 'resume.png', () => { this.onWatchAd(0) }, true)
        this.cancelAdButton = this.createButton(120, 50, 'exit.png', () => { this.onRewardsAd(false) }, true)
        this.rewardAdsScreen.add([this.watchAdButton, this.cancelAdButton]);
        this.rewardAdsScreen.setDepth(10)
        this.rewardAdsScreen.setVisible(false);

        this.countDownTween = this.tweens.addCounter({
            from: 0,
            to: 5,
            duration: 5 * 1000,
            onComplete: function () {
                //this.onWatchAd(1);
                this.onRewardsAd(false);
            },
            onCompleteScope: this,
            onUpdate: function () {
                var value = 5 - Phaser.Math.FloorTo(this.countDownTween.getValue(), 0, 10);
                this.watchAdCountDownText.setText(value.toString());
            },
            onUpdateScope: this,
            paused: true
        });
    }

    openWatchAdScreen() {
        this.feedbackText.scale = this.feedbackText.alpha = 0;
        this.watchAdCountDownText.setVisible(true);
        this.countDownTween.play();
        this.watchAdText.setVisible(true);
        this.rewardAdsScreen.setVisible(true)
        this.pauseButton.setVisible(false)
    }

    onWatchAd(index: number) {
        if (index == 0) {
            if (this.soundOn) {
                this.buttonSFX.play();
            }
        }
        this.countDownTween.stop();
        this.watchAdCountDownText.setVisible(false);
        this.watchAdText.setVisible(false);
        this.rewardAdsScreen.setVisible(false);
        this.game.sound.mute = true;
        //this.showAd();
        this.continueRespawn();
    }

    public onRewardsAd(adWatched: boolean) {
        this.countDownTween.stop();
        this.watchAdCountDownText.setVisible(false);
        this.watchAdText.setVisible(false);
        this.rewardAdsScreen.setVisible(false);

        console.log("adcloase");


        App.MUTE ? this.game.sound.mute = true : this.game.sound.mute = false;
        if (adWatched) {
            // Respawn player with 1 life       
            App.totalLives += 1;
            Game.uiScene.events.emit('rewardLife');

        }
        else {
            if (this.soundOn) {
                this.buttonSFX.play();
            }
            // show game over
            this.watchAdCountDownText.setVisible(false);
            if (this.countDownTween != null) {
                this.countDownTween.stop();
            }
            this.OnGameOver();
        }
        this.gameScene.events.emit('onReward');
    }

    createGameEndScreen() {

        if (this.finalScore > this.highScore) {
            GameConfig.highScore = this.finalScore;
            this.highScore = this.finalScore;
        }

        this.gameOverPanel = this.add.sprite(0, 0, 'panel');
        this.gameOverPanel.setDepth(2);
        this.gameOverPanel.scale = 0.85;

        this.gameOverText = this.createText("GAME OVER", 0, -165);
        this.SetTextStyle(this.gameOverText, 40, 10);

        this.currentScoreText = this.createText("CURRENT SCORE", 0, -80);
        this.SetTextStyle(this.currentScoreText, 30, 0);

        this.currentScorediamondIcon = this.add.sprite(-50, -18, 'sprites', 'gem.png');
        this.currentScorediamondIcon.setScale(0.8);

        this.finalScoreText = this.createText(this.finalScore.toString(), 55 + this.finalScoreOffSet, -18);
        this.SetTextStyle(this.finalScoreText, 50, 0);

        this.highScoreTextUI = this.createText("HIGH SCORE", 0, 45);
        this.SetTextStyle(this.highScoreTextUI, 35, 0);

        this.highScoreDiamondIcon = this.add.sprite(-50, 110, 'sprites', 'gem.png');
        this.highScoreDiamondIcon.setScale(0.8);

        this.highScoreText = this.createText(this.highScore.toString(), 55 + this.highScoreOffSet, 110);
        this.SetTextStyle(this.highScoreText, 50, 0);

        this.highScoreGratification = this.add.sprite(-120, 110, 'new');
        this.highScoreGratification.setDepth(15);
        this.highScoreGratification.scale = 0.8;
        this.highScoreGratification.setVisible(false);

        this.replayButton = this.create_Button(0, 190, "greenbutton", this.OnGameEndReplay.bind(this), true);

        this.replayText = this.createText("REPLAY", 0, 190);
        this.SetTextStyle(this.replayText, 30, 5);

        this.gameOverScreen.add([this.gameOverPanel, this.gameOverText, this.currentScoreText, this.currentScorediamondIcon, this.finalScoreText, this.highScoreTextUI, this.highScoreDiamondIcon, this.highScoreText, this.highScoreGratification, this.replayButton, this.replayText]);
        this.gameOverScreen.scale = 1;

        this.gameOverScreen.setVisible(false);
        // this.replayButton.setVisible(false);
        // this.replayText.setVisible(false);

        this.replayButton.on('pointerdown', () => {
            console.log("restart");
        });
    }

    EnableGameEndScreen(bool: boolean) {
        //console.log("This function is called");
        this.gameOverScreen.setVisible(bool);
    }

    OnGameEndReplay() {
        this.EnableGameEndScreen(false)
        this.scoreHUD.setVisible(true)
        this.Restart();
    }

    OnPause() {
        if (this.soundOn) {
            this.buttonSFX.play();
        }
        window.clearTimeout(UIManager.respawnTimeout);
        this.isPaused = true;
        this.events.emit('pause');
        this.OpenPauseWindow()
        App.gamezopSDK.setGameState(GAMEZOP_STATE.PAUSED, this.finalScore, App.gamezopSDK.getHighscore());
    }

    private isPaused: boolean = false;

    sdkPause() {
        window.clearTimeout(UIManager.respawnTimeout);
        this.muteAudio()
        if(!this.isGameover){
            App.gamezopSDK.setGameState(GAMEZOP_STATE.PAUSED, this.finalScore, App.gamezopSDK.getHighscore());
        }
        this.events.emit('pause');
    }

    private isGameover: boolean = false;
    sdkResume() {
        this.scene.resume('game');
        this.events.emit('resume');
        if (!this.isGameover) {
            this.unMuteAudio();
            App.gamezopSDK.setGameState(GAMEZOP_STATE.PLAYING, this.finalScore, App.gamezopSDK.getHighscore());
        }
    }

    Restart() {
        if (Game.isBattleMode) {
            Game.isInput = false;
        }
        if (this.isPaused == true) {
            App.gamezopSDK.setGameState(GAMEZOP_STATE.OVER, this.finalScore, App.gamezopSDK.getHighscore());
            this.isPaused = false;
        }
        this.isGameover = false
        this.EnableGameEndScreen(false);
        // this.TweenStartText();
        App.gamezopSDK.getMetadata();
        this.getHighScoreFromCloud();
        App.gamezopSDK.onGameReset();
        App.totalLives = 3;
        this.feedbackText.alpha = 0;
        this.scene.resume('game');
        this.scoreHUD.text = "0";
        this.livesHUD.text = " x " + App.totalLives;
        this.events.emit('restart');
        this.ClosePauseWindow(true)
        this.pauseButton.setVisible(false);
        this.audioToggleButton.setVisible(true);
        this.highScoreGratification.setVisible(false);
        this.enableBlackScreen(false);
    }

    Resume() {
        if (this.soundOn) {
            this.buttonSFX.play();
        }
        this.isPaused = false;
        this.scene.resume('game');
        this.events.emit('resume');
        this.ClosePauseWindow(true);
        App.gamezopSDK.setGameState(GAMEZOP_STATE.PLAYING, this.finalScore, App.gamezopSDK.getHighscore());
    }

    Exit() {
        if (this.soundOn) {
            this.buttonSFX.play();
        }
    }

    ToggleAudio() {
        // if (this.soundOn) {
        //     this.buttonSFX.play();
        // }
        this.soundOn = !this.soundOn;
        if (this.soundOn) {
            // this.audioToggle.setTexture('sprites', 'soundOn.png')
            App.gamezopSDK.gameMuted(false);
            this.audioToggleButton.setTexture('sprites', 'soundOn.png');
        } else {
            // this.audioToggle.setTexture('sprites', 'soundOff.png')
            App.gamezopSDK.gameMuted(true);
            this.audioToggleButton.setTexture('sprites', 'soundOff.png');
        }
        this.events.emit('toggleAudio', this.soundOn);
    }

    muteAudio() {
        this.soundOn = false;
        App.gamezopSDK.gameMuted(true);
        this.audioToggleButton.setTexture('sprites', 'soundOff.png');
        this.events.emit('toggleAudio', false);
    }

    unMuteAudio() {
        this.soundOn = true;
        App.gamezopSDK.gameMuted(false);
        this.audioToggleButton.setTexture('sprites', 'soundOn.png');
        this.events.emit('toggleAudio', true);
    }

    updateScore(score: number) {
        this.scoreHUD.alpha = 1;
        this.tweens.add({
            targets: this.scoreHUD, scale: 1.25, duration: 100, onComplete: () => {
                this.tweens.add({
                    targets: this.scoreHUD, scale: 1, duration: 100
                });
            }
        });

        this.scoreHUD.text = score.toString();
        this.registry.set('score', score);
        this.finalScore = score;
        if (Game.isBattleMode) {
            App.gamezopSDK.setGameState(GAMEZOP_STATE.PLAYING, this.finalScore, App.gamezopSDK.getHighscore());
            //console.log("Keep Updating the score in battle mode", this.finalScore);
        }

        if (score > this.highScore || this.highScore == null) {
            this.highScore = score;
            // this.registry.set('highScore', this.highScore);
        }
    }

    OnPerfectTurn(perfectCount: number) {

        this.feedbackText.scale = this.feedbackText.alpha = 0;
        let append = "";
        if (perfectCount > 0) {
            append = " X " + perfectCount;
        }
        this.feedbackText.text = "PERFECT" + append;

        this.tweens.add({
            targets: this.feedbackText, scale: 1, duration: 250, ease: Phaser.Math.Easing.Back.Out, setParams: [3]
        });

        this.feedbackTextTween = this.tweens.add({
            targets: this.feedbackText, alpha: 1, duration: 100
        });

        this.Delay(1000, () => {
            this.feedbackTextTween = this.tweens.add({
                targets: this.feedbackText, alpha: 0, scale: 1.8, duration: 300
            });
        })
    }


    OnGameOver() {
        Game.setCameraZoom(Game.zoomOutCamera, true);
        this.finalScore = this.registry.get('score');
        // this.highScore = GameConfig.highScore;
        this.feedbackText.scale = 0;
        this.feedbackText.text = "GAME OVER!";
        this.pauseButton.setVisible(false);
        this.audioToggleButton.setVisible(false);
        this.tweens.add({
            targets: this.feedbackText, scale: 1, duration: 450, ease: Phaser.Math.Easing.Back.Out, setParams: [3]
        });

        this.feedbackTextTween = this.tweens.add({
            targets: this.feedbackText, alpha: 1, duration: 200
        });

        this.feedbackTextTween = this.tweens.add({
            targets: this.feedbackText, alpha: 0, scale: 1.8, delay: 1800, duration: 300, onComplete: () => {
                this.updateTextScores();
                Game.isInput = true;
                if (Game.isBattleMode) {
                    this.muteAudio()
                }
                this.isGameover = true;
                if (this.finalScore >= this.highScore) {
                    GameConfig.highScore = this.finalScore;
                    this.setHighScoreToCloud(this.finalScore);
                    this.highScore = this.finalScore;
                    Game.SaveData();
                    this.highScoreGratification.setVisible(true);
                }
                if (!Game.isBattleMode) {
                    App.gamezopSDK.setGameState(GAMEZOP_STATE.OVER, this.finalScore, App.gamezopSDK.getHighscore());
                    // this.showAd()
                    this.EnableGameEndScreen(true);
                }
                Game.currentGameState = GameState.Gameover;
            }
        });
    }

    updateTextScores() {
        // this.finalScoreOffSet = 0;
        // this.highScoreOffSet = 0;

        // if (this.finalScore <= 9) {
        //     this.finalScoreOffSet = 70;
        // }
        // else if (this.finalScore <= 99) {
        //     this.finalScoreOffSet = 60;
        // }
        // else if (this.finalScore <= 999) {
        //     this.finalScoreOffSet = 90;
        // }
        // else {
        //     this.finalScoreOffSet = 129;
        // }

        // if (this.highScore <= 9) {
        //     this.highScoreOffSet = 70;
        // }
        // else if (this.highScore <= 99) {
        //     this.highScoreOffSet = 60;
        // }
        // else if (this.highScore <= 999) {
        //     console.log("Offset 3 digits number");
        //     this.highScoreOffSet = 90;
        // }
        // else {
        //     this.highScoreOffSet = 120;
        // }

        this.finalScoreText.text = this.finalScore.toString();
        this.highScoreText.text = this.highScore.toString();
    }

    startTextTween: any;

    TweenStartText() {
        this.SetTextStyle(this.gameStartText, 30, 15)

        this.SetTextStyle(this.scoreHUD, 20, 0, 'russo')
        this.SetTextStyle(this.livesHUD, 20, 0, 'russo')

        // this.audioToggle.setVisible(true)
        this.gameStartText.setVisible(true);
        this.hud.setVisible(true)
        this.gameStartText.alpha = 1;
        this.gameStartText.scale = 1.2;
        this.pauseButton.setVisible(false);
        // App.loadingScreen.destroy();
        // Game.currentGameState = 0;
        
        
    }

    startTheTimer() {
        if (Game.isBattleMode) {
            var seconds: number = 4;
            var startingValue = { value: seconds };
            var endingValue = { value: 0 }
            let self = this;
            this.tweens.add({
                targets: startingValue,
                value: endingValue,
                duration: seconds * 1000,
                ease: 'Linear',
                onUpdate: function (tween, target) {
                    if (target.value > 0) {
                        self.gameStartText.text = "Starting In " + Math.floor(target.value).toString();
                    }
                    if (target.value < 1) {
                        self.gameStartText.text = "Go!";
                    }
                },
                onComplete: function (tween, target) {
                    Game.isInput = true;
                    Game.isInput = false;
                    self.EnableGameEndScreen(false);
                    self.TweenStartText();
                    App.gamezopSDK.getMetadata();
                    self.getHighScoreFromCloud();
                    App.gamezopSDK.onGameReset();
                    self.feedbackText.alpha = 0;
                    self.scoreHUD.text = "0";
                    self.livesHUD.text = " x " + App.totalLives;
                    self.ClosePauseWindow(true)
                    self.pauseButton.setVisible(false);
                    self.audioToggleButton.setVisible(true);
                    self.highScoreGratification.setVisible(false);
                    self.enableBlackScreen(false);
                    self.gameScene.events.emit('onGameStart');
                }
            })
        }
    }

    tweenTexts() {
        let gratificationTween: any;
        gratificationTween = this.tweens.add({
            targets: this.highScoreGratification, scale: 1, duration: 800, loop: -1, yoyo: true
        });

        this.startTextTween = this.tweens.add({
            targets: this.gameStartText, ease: 'Cubic.Out', scale: 1.4, duration: 600, loop: -1, yoyo: true
        });

        let blackScreenTweenText: any

        blackScreenTweenText = this.tweens.add({
            targets: this.blackScreenText, ease: 'Cubic.Out', scale: 1.2, duration: 600, loop: -1, yoyo: true
        });

    }
    startLogoTween: any;

    GameStart() {
        // if (this.startTextTween) {
        //     this.startTextTween.stop();
        // }
        if (this.gameStartText.active) {
            this.eventFired = false;
            this.gameStartText.alpha = 1;
            this.gameStartText.scale = 1;
            if (Game.isBattleMode) {
                this.pauseButton.setVisible(false);
            } else {
                this.pauseButton.setVisible(true);
            }

            this.gameStartText.setVisible(false);

            this.getHighScoreFromCloud();


            App.gamezopSDK.setGameState(GAMEZOP_STATE.PLAYING, 0, App.gamezopSDK.getHighscore());
            // this.Delay(200, () => {
            //     this.tweens.add({
            //         targets: this.gameStartText, alpha: 0, scale: 2, duration: 300
            //     });
            // });
            Game.setCameraZoom(Game.zoomOutCamera, true);

            this.startLogoTween = this.tweens.add({
                targets: this.startLogo,
                x: this.centerX,
                y: this.centerY + 800,
                duration: 200,
                loop: 0,
            })
        }
    }

    OnLevelUp() {
        this.SetTextStyle(this.levelUpText, 40, 10)

        this.levelUpText.setVisible(true);
        this.levelUpText.x = -300;
        this.levelUpText.alpha = 1;
        this.blackPanel.setAlpha(0.7);
        this.blackPanel.setVisible(true)

        this.tweens.add({
            targets: this.levelUpText,
            x: this.centerX,
            duration: 350,
            ease: Phaser.Math.Easing.Back.Out,
            easeParams: [1],
            onComplete: () => {

                this.tweens.add({
                    targets: this.levelUpText,
                    x: this.width + 200,
                    delay: 1500,
                    duration: 350,
                    ease: Phaser.Math.Easing.Back.In,
                    easeParams: [1],
                    onComplete: () => {
                        this.levelUpText.setVisible(false);
                    }
                });

                this.tweens.add({
                    targets: this.blackPanel, alpha: 0, delay: 1500, duration: 350
                });
            }
        });
    }

    endBattleMode() {
        if (Game.isBattleMode) {
            // UIManager.respawnTimeout.stop();
            this.feedbackText.text = " ";
            this.muteAudio()
            this.enableBlackScreen(true);
            this.finalScore = this.registry.get('score');
            Game.setCameraZoom(Game.zoomOutCamera, true);
            //console.log("FinalScore", this.finalScore);
            //console.log("HighScore", this.finalScore);
            if (this.finalScore >= this.highScore) {
                GameConfig.highScore = this.finalScore;
                this.setHighScoreToCloud(this.finalScore);
                this.highScore = this.finalScore;
                Game.SaveData();
                //console.log("Highscore in battle mode");
            }
        }
    }


    private eventFired: boolean = false
    updateLifeUI(lifeCount: number) {
        if (lifeCount == 0) {
            this.feedbackText.scale = this.feedbackText.alpha = 1;
            this.feedbackText.text = "Crashed! ";
            if (Game.isBattleMode) {
                this.enableBlackScreen(true);
                this.endBattleMode();
                if (!this.eventFired) {
                    this.eventFired = true;
                    App.gamezopSDK.setGameState(GAMEZOP_STATE.OVER, this.finalScore, App.gamezopSDK.getHighscore());
                }
            }
        }
        this.livesHUD.text = 'x ' + lifeCount.toString();
        this.pauseButton.setVisible(false);
    }


    Respawn(lifeCount: number) {
        // App.gamezopSDK.setGameState(GAMEZOP_STATE.CONTINUE, this.finalScore, App.gamezopSDK.getHighscore());
        Game.setCameraZoom(Game.zoomOutCamera, true);
        if (Game.isBattleMode) {
            var seconds: number = 3;
            var startingValue = { value: seconds };
            var endingValue = { value: 0 }
            let self = this;
            self.feedbackText.text = "Respawn In " + " " + seconds.toString();
            UIManager.respawnTimeout = this.tweens.add({
                targets: startingValue,
                value: endingValue,
                duration: seconds * 1000,
                ease: 'Linear',
                onUpdate: function (tween, target) {
                    if (Math.round(target.value) >= 1) {
                        self.feedbackText.scale = self.feedbackText.alpha = 1;
                        self.feedbackText.text = "Respawn In " + " " + Math.round(target.value).toString();
                    }
                },
                onComplete: function (tween, target) {
                    self.continueRespawn();
                }
            });
        }
        else {
            this.enableRespawnScreen(true);
            this.feedbackText.scale = this.feedbackText.alpha = 1;
            this.feedbackText.text = " ";
            this.pauseButton.setVisible(false);
            var seconds: number = 5;
            var startingValue = { value: seconds };
            var endingValue = { value: 0 }
            let self = this;
            this.respawnText.text = "Continue In" + " " + seconds.toString();
            UIManager.respawnTimeout = this.tweens.add({
                targets: startingValue,
                value: endingValue,
                duration: seconds * 1000,
                ease: 'Linear',
                onUpdate: function (tween, target) {
                    if (Math.round(target.value) >= 1) {
                        self.respawnText.text = "Continue In" + " " + Math.round(target.value).toString();
                    }
                },
                onComplete: function (tween, target) {
                    self.updateLifeUI(App.totalLives);
                    self.OnGameOver();
                    self.enableRespawnScreen(false);
                }
            });

        }
    }

    Tutorial() {
        this.feedbackText.alpha = this.feedbackText.scale = 1;
        this.feedbackText.text = "Press and hold to drift";
        this.Delay(1900, () => {
            this.feedbackText.alpha = 0;
        });
    }

    OpenPauseWindow() {
        if (this.feedbackTextTween) {
            this.feedbackTextTween.stop()
        }
        this.feedbackText.alpha = 0;
        this.pauseScreen.setVisible(true);
    }


    ClosePauseWindow(enablePauseButton?: boolean) {
        this.pauseScreen.setVisible(false)
        this.pauseButton.setVisible(enablePauseButton)
    }

    enableRespawnScreen(isVisible: boolean) {
        this.respawnScreen.setVisible(isVisible);
    }

    enableBlackScreen(isVisible: boolean) {
        this.blackScreenContainer.setVisible(isVisible)
    }

    continueRespawn() {
        this.gameScene.events.emit('respawn');
        UIManager.respawnTimeout.stop();
        this.updateLifeUI(App.totalLives);
        this.enableRespawnScreen(false);
        this.feedbackText.scale = this.feedbackText.alpha = 0;
        if (Game.isBattleMode) {
            this.pauseButton.setVisible(false);
        }
        else {
            this.pauseButton.setVisible(true);
        }
        // App.gamezopSDK.setGameState(GAMEZOP_STATE.PLAYING, this.finalScore, App.gamezopSDK.getHighscore());
        Game.setCameraZoom(Game.zoomOutCamera, true);
        if (!Game.isBattleMode) {
            // this.showAd();
        }
    }

    Delay(duration: number, callback: Function) {
        this.time.addEvent({
            delay: duration,
            callback: callback,
            callbackScope: this
        })
    }
}